import { render, staticRenderFns } from "./OperaOrderDetail.vue?vue&type=template&id=f8357cd4&scoped=true&"
import script from "./OperaOrderDetail.vue?vue&type=script&lang=js&"
export * from "./OperaOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaOrderDetail.vue?vue&type=style&index=0&id=f8357cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8357cd4",
  null
  
)

export default component.exports